module.exports = {
  title: 'Story List UI App in React Native 📚',
  author: 'Enzo Manuel Mangano',
  date: '2023-03-15',
  slug: 'story-list',
  tags: ['reanimated', 'gesture-handler'],
};
